/**
 * @flow
 * @relayHash 9a2322c5f4777f242a93d11784a72a94
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EncodedRevenueValueTypeEnum = "AMAZON_CPM" | "%future added value";
export type LogUserRevenueAggregationOperationEnum = "MAX" | "%future added value";
export type LogUserRevenueInput = {
  userId: string,
  revenue?: ?number,
  encodedRevenue?: ?EncodedRevenueValue,
  aggregationOperation?: ?LogUserRevenueAggregationOperationEnum,
  dfpAdvertiserId?: ?string,
  adUnitCode?: ?string,
  tabId?: ?string,
  adSize?: ?string,
  clientMutationId?: ?string,
};
export type EncodedRevenueValue = {
  encodingType: EncodedRevenueValueTypeEnum,
  encodedValue: string,
  adSize?: ?string,
};
export type LogUserRevenueMutationVariables = {|
  input: LogUserRevenueInput
|};
export type LogUserRevenueMutationResponse = {|
  +logUserRevenue: ?{|
    +success: boolean
  |}
|};
export type LogUserRevenueMutation = {|
  variables: LogUserRevenueMutationVariables,
  response: LogUserRevenueMutationResponse,
|};
*/


/*
mutation LogUserRevenueMutation(
  $input: LogUserRevenueInput!
) {
  logUserRevenue(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserRevenueInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserRevenue",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogUserRevenueInput!"
      }
    ],
    "concreteType": "LogUserRevenuePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "LogUserRevenueMutation",
  "id": null,
  "text": "mutation LogUserRevenueMutation(\n  $input: LogUserRevenueInput!\n) {\n  logUserRevenue(input: $input) {\n    success\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LogUserRevenueMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "LogUserRevenueMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15f5cc90b9b7975a47fe8855e9d34cda';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/LogUserRevenueMutation.graphql.js